function SkeletonBar({ className }: { className?: string }) {
    return (
        <div
            className={`rounded-lg bg-white/[0.06] animate-pulse ${className ?? ''}`}
            aria-hidden
        />
    );
}

export default function ChapterLoading() {
    return (
        <div className="min-h-screen bg-black text-white">
            <header className="fixed top-0 left-0 right-0 z-50 h-14 border-b border-white/5 bg-zinc-950/80 backdrop-blur-xl px-4 flex items-center gap-3">
                <SkeletonBar className="h-8 w-8 rounded-full shrink-0" />
                <div className="flex-1 space-y-2 min-w-0">
                    <SkeletonBar className="h-3 w-[45%] max-w-[200px]" />
                    <SkeletonBar className="h-2.5 w-[30%] max-w-[120px]" />
                </div>
                <SkeletonBar className="h-8 w-20 rounded-lg shrink-0" />
            </header>

            <main className="max-w-4xl mx-auto min-h-screen bg-black pt-14 pb-32 px-3 sm:px-4">
                <div className="space-y-3 pt-4">
                    <SkeletonBar className="h-[min(72vh,640px)] w-full max-w-2xl mx-auto rounded-md" />
                    <div className="flex justify-center gap-2 pt-2">
                        <SkeletonBar className="h-9 w-9 rounded-full" />
                        <SkeletonBar className="h-9 w-24 rounded-lg" />
                        <SkeletonBar className="h-9 w-9 rounded-full" />
                    </div>
                    <div className="grid grid-cols-2 gap-2 max-w-2xl mx-auto pt-6 opacity-80">
                        <SkeletonBar className="h-24 rounded-md" />
                        <SkeletonBar className="h-24 rounded-md" />
                        <SkeletonBar className="h-24 rounded-md" />
                        <SkeletonBar className="h-24 rounded-md" />
                    </div>
                </div>
            </main>

            <div
                className="fixed z-40 left-1/2 -translate-x-1/2 bottom-[max(1.5rem,env(safe-area-inset-bottom))] w-[92%] max-w-xl h-14 rounded-full bg-white/[0.06] border border-white/10 animate-pulse md:max-w-md"
                aria-hidden
            />
        </div>
    );
}
